export default __webpack_public_path__ + "static/media/Football.8b26f1ad.svg";